import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'raf-tab-container',
  templateUrl: './tab-container.component.html',
  styleUrls: ['./tab-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabContainerComponent {
  @Input()
  tabletLayout?: boolean | null = false;

  @Input()
  sticky?: boolean | null = false;

  @HostBinding('class.tabletBreakpoint')
  get hostClass() {
    return this.tabletLayout;
  }

  @HostBinding('class.tab-container-sticky')
  get hostClassSticky() {
    return this.sticky;
  }

  @HostBinding('class.tab-container')
  tabHostClass = true;
}
